import { BaseType } from '../../base/base-type';
import { IdentityTypeIdEnum } from '../../enum/shared/identity-type-id.enum';

export class IdentityType extends BaseType {
  public declare id: IdentityTypeIdEnum;
}
